import { Controller } from "@hotwired/stimulus"

// Backs the dark-mode switch on the Settings page. Applies the choice
// immediately -- data-bs-theme on <html>, which every Bootstrap component
// reads its colors from, plus a cookie so the same instant behavior still
// works for a signed-out visitor with no account yet (see
// ApplicationController#current_theme) -- and persists it to the
// signed-in user's account via a PATCH to persistUrlValue
// (ThemesController#update). That account-level save is what makes the
// choice follow them to a different browser or device, not just this one;
// this controller only ever renders on the Settings page, which requires
// being signed in, so there's always an account to save it to.
export default class extends Controller {
  static values = { persistUrl: String }

  static COOKIE_NAME = "theme"
  static COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

  toggle(event) {
    const next = event.target.checked ? "dark" : "light"
    document.documentElement.dataset.bsTheme = next
    document.cookie = `${this.constructor.COOKIE_NAME}=${next}; path=/; max-age=${this.constructor.COOKIE_MAX_AGE}; samesite=lax`
    this.persist(next)
  }

  persist(theme) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Fire-and-forget: the cookie + DOM update above already gave the
    // user instant feedback, so a slow or failed request here just means
    // the choice won't have followed them to their next device this
    // time -- not worth blocking or erroring the click over.
    fetch(this.persistUrlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken },
      body: JSON.stringify({ theme })
    }).catch(() => {})
  }
}
